import { render, staticRenderFns } from "./SelectSearchEventsDropdown.vue?vue&type=template&id=2c65e8a6&"
import script from "./SelectSearchEventsDropdown.vue?vue&type=script&lang=js&"
export * from "./SelectSearchEventsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./SelectSearchEventsDropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports